<template>
    <router-link v-if="field === 'name'" :to="{ name: 'projects.show', params: { slug: item.id } }">
        {{ $filters.valueOrDefault(item.name ) }}
    </router-link>

    <span v-else-if="field === 'completion_date'">
        {{ $filters.date(item.completion_date) }}
    </span>

    <router-link v-else-if="field === 'id'" :to="{ name: 'projects.show', params: { slug: item.id } }">
        {{ $filters.valueOrDefault(projectNameById(item.id)) }}
    </router-link>
    <span v-else-if="field === 'bbl'">{{ $filters.projectBBL(item) }}</span>
    <span v-else-if="field === 'address'">{{ item.building }} {{ item.street }}</span>
    <span v-else-if="field === 'borough'">{{ item.borough }}</span>
    <span v-else-if="field === 'status'">{{ $filters.valueOrDefault(statusNameById(item.status)) }}</span>
    <span v-else-if="field === 'company_id'">
        <router-link :to="{ name: 'companies.show', params: { slug: item.company_id } }">
            {{ $filters.valueOrDefault(item.company_name ) }}
        </router-link>
    </span>
    <span v-else-if="field === 'assigned_to' && item.assigned_to !== null">
        <router-link :to="{ name: 'users.show', params: { slug: item.assigned_to } }">
            {{ $filters.valueOrDefault(userNameById(item.assigned_to), userNameById(item.assigned_to)) }}
        </router-link>
    </span>
    <span v-else-if="field === 'senior_pm_id'">
        <router-link :to="{ name: 'users.show', params: { slug: item.senior_pm_id } }">
            {{ $filters.valueOrDefault(userNameById(item.senior_pm_id)) }}
        </router-link>
    </span>
    <div v-else-if="field === 'latest_note'" v-html="latestNoteMessageByProjectId(item.id)" class="latest-note-message"></div>
    <span v-else-if="field === 'created_at'">{{ $filters.datetime(item.created_at ) }}</span>
    <span v-else-if="field === 'updated_at'">{{ $filters.datetime(item.updated_at ) }}</span>
    <span v-else-if="field == 'latest_task'">
        <router-link :to="{ name: 'tasks.show', params: { slug: item.latest_task }}">
            {{ taskNameById(item.latest_task) }}
        </router-link>
    </span>
    <router-link v-else-if="field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: item.last_editor_id } }">
        {{ userNameById(item.last_editor_id) }}
    </router-link>
    <span v-else-if="field === 'notable'"><o-icon pack="fa" v-if="item.notable" icon="check"></o-icon></span>
    <span v-else-if="field === 'project_type'">{{ projectTypeNameById(item.project_type) }}</span>
</template>

<script>
    import { mapGetters } from 'vuex'
    import $filters from "../../filters";

    export default {
        props: ['field', 'item'],

      computed: {
            ...mapGetters(['companyNameById', 'projectNameById', 'userNameById', 'latestNoteMessageByProjectId', 'taskNameById', 'projectTypeNameById'])
        },
    }
</script>

<style scoped>
.latest-note-message {
  word-break: break-word;
  white-space: pre-wrap;
}
</style>
